import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  minify1kh64osmcox7j as minify,
  access$formatDecodingException$tJsonExceptionsKt2yfifxvnjk03f as access$formatDecodingException$tJsonExceptionsKt,
  InvalidKeyKindException3b5w96w0jjxof as InvalidKeyKindException,
  access$nonFiniteFpMessage$tJsonExceptionsKt13lbsnfrx5cw2 as access$nonFiniteFpMessage$tJsonExceptionsKt,
} from './JsonExceptions.mjs';
import { JsonDecodingExceptionoyag1psadwuw as JsonDecodingException } from '../JsonExceptions.mjs';
import { NamedValueDecoderzk26ztf92xbq as NamedValueDecoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Tagged.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
import {
  classDiscriminator9fd3hvqsgfqq as classDiscriminator,
  subtypeNotRegisteredMessageJson3mtuvvd9idjxz as subtypeNotRegisteredMessageJson,
} from './JsonPolymorphicHelpers.mjs';
import {
  JsonObjectee06ihoeeiqj as JsonObject,
  get_jsonPrimitivez17tyd5rw1ql as get_jsonPrimitive,
  get_contentOrNull35s97cgi8z9eo as get_contentOrNull,
  JsonArray2urf8ey7u44sd as JsonArray,
  JsonNull2liwjj96vm0w2 as JsonNull,
  JsonPrimitive3ttzjh2ft5dnx as JsonPrimitive,
  JsonNull_getInstance1i1hv1sbjynto as JsonNull_getInstance,
  get_booleanOrNull376axlcpdhkmo as get_booleanOrNull,
  parseLongImpl2gkj8byk018b9 as parseLongImpl,
  get_float1xtaobzj8js8m as get_float,
  get_double1785hcxaminy4 as get_double,
  JsonLiteral1u57id0qmqut7 as JsonLiteral,
  JsonPrimitiveolttw629wj53 as JsonPrimitive_0,
} from '../JsonElement.mjs';
import {
  getKClass3t8tygqu4lcxf as getKClass,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { DeserializationStrategy1z3z5pj9f7zc8 as DeserializationStrategy } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Exceptiondt2hlxn7j7vw as Exception,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
  MissingFieldException24tqif29emcmi as MissingFieldException,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { contains3ue2qo8xhmpf1 as contains } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { plus17rl43at52ays as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { missingFieldExceptionWithNewMessage2gqddjx5jxge9 as missingFieldExceptionWithNewMessage } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/JsonInternalDependencies.mjs';
import {
  PolymorphicKindla9gurooefwb as PolymorphicKind,
  LIST_getInstance2vniy0f7mmb29 as LIST_getInstance,
  ENUM_getInstance25239ht7oag6o as ENUM_getInstance,
  PrimitiveKindndgbuh6is7ze as PrimitiveKind,
  MAP_getInstance3e78m6vf98i66 as MAP_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { carrierDescriptor9eih94weel9f as carrierDescriptor } from './LexerMode.mjs';
import {
  getJsonNameIndexOrThrow1a6a29i1xie0m as getJsonNameIndexOrThrow,
  getJsonNameIndex1fee1p51fy8fj as getJsonNameIndex,
  ignoreUnknownKeys1ot1okvsp9ttf as ignoreUnknownKeys,
} from './JsonNamesMap.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/rangeTo.mjs';
import { ClosedRangehokgr73im9z3 as ClosedRange } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/Range.mjs';
import { contains2c50nlxg7en7o as contains_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import {
  convertToByte2t4hntblnhq2k as convertToByte,
  convertToShortn6n5n7ruahkm as convertToShort,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { single29ec4rh52687r as single } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { Char19o2r8palgjof as Char } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { StringJsonLexer3eu6xom7mrcfu as StringJsonLexer } from './StringJsonLexer.mjs';
import { JsonDecoderForUnsignedTypesaowwj2t4rf8t as JsonDecoderForUnsignedTypes } from './StreamingJsonDecoder.mjs';
import { get_isUnsignedNumber3dxwaa3af8ncr as get_isUnsignedNumber } from './StreamingJsonEncoder.mjs';
import { JsonDecoder1rijst5ne6qla as JsonDecoder } from '../JsonDecoder.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { JsonElementMarker395jk2pil4789 as JsonElementMarker } from './JsonElementMarker.mjs';
import { getValue48kllevslyh6 as getValue } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { toInt2q8uldh7sc951 as toInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function readPolymorphicJson(_this__u8e3s4, discriminator, element, deserializer) {
  var descriptor = deserializer.b1n();
  return (new (JsonTreeDecoder())(_this__u8e3s4, element, descriptor, discriminator, descriptor)).r1r(deserializer);
}
function unparsedPrimitive($this, literal, primitive, tag) {
  var type = startsWith(primitive, 'i') ? 'an ' + primitive : 'a ' + primitive;
  var tmp2 = "Failed to parse literal '" + literal.toString() + "' as " + type + ' value';
  // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
  var path = $this.g2x(tag);
  var tmp;
  if ($this.p2q().i2o_1.n2q_1) {
    var tmp$ret$3 = toString($this.h2x());
    tmp = toString(minify(tmp$ret$3));
  } else {
    tmp = null;
  }
  var inputValue = tmp;
  throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
}
var AbstractJsonTreeDecoderClass;
function AbstractJsonTreeDecoder() {
  if (AbstractJsonTreeDecoderClass === VOID) {
    class $ extends NamedValueDecoder() {
      constructor(json, value, polymorphicDiscriminator) {
        polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
        super();
        this.c2x_1 = json;
        this.d2x_1 = value;
        this.e2x_1 = polymorphicDiscriminator;
        this.f2x_1 = this.p2q().i2o_1;
      }
      p2q() {
        return this.c2x_1;
      }
      n3() {
        return this.d2x_1;
      }
      h1s() {
        return this.p2q().h1s();
      }
      h2x() {
        var tmp0_safe_receiver = this.s27();
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = this.i2x(tmp0_safe_receiver);
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? this.n3() : tmp1_elvis_lhs;
      }
      g2x(currentTag) {
        return this.u27() + ('.' + currentTag);
      }
      q2q() {
        return this.h2x();
      }
      r1r(deserializer) {
        var tmp2_withExceptionHandling_this = this.h2x();
        // Inline function 'kotlinx.serialization.json.internal.withExceptionHandling' call
        var tmp;
        try {
          var tmp$ret$2;
          $l$block: {
            // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
            var tmp_0;
            if (!(deserializer instanceof AbstractPolymorphicSerializer())) {
              tmp_0 = true;
            } else {
              tmp_0 = this.p2q().i2o_1.e2q_1;
            }
            if (tmp_0) {
              tmp$ret$2 = deserializer.d1n(this);
              break $l$block;
            }
            var discriminator = classDiscriminator(deserializer.b1n(), this.p2q());
            var tmp2 = this.q2q();
            // Inline function 'kotlinx.serialization.json.internal.cast' call
            var serialName = deserializer.b1n().e1o();
            if (!(tmp2 instanceof JsonObject())) {
              var tmp2_0 = 'Expected ' + getKClass(JsonObject()).j1() + ', but had ' + getKClassFromExpression(tmp2).j1() + ' as the serialized body of ' + serialName;
              // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
              var path = this.u27();
              var tmp_1;
              if (this.p2q().i2o_1.n2q_1) {
                var tmp$ret$8 = toString(tmp2);
                tmp_1 = toString(minify(tmp$ret$8));
              } else {
                tmp_1 = null;
              }
              var inputValue = tmp_1;
              throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, path, null, inputValue), tmp2_0, -1, path, inputValue, null);
            }
            var jsonTree = tmp2;
            var tmp0_safe_receiver = jsonTree.t2q(discriminator);
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
            var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
            var tmp_2 = deserializer.u1n(this, type);
            var actualSerializer = (!(tmp_2 == null) ? isInterface(tmp_2, DeserializationStrategy()) : false) ? tmp_2 : null;
            if (actualSerializer == null) {
              var _destruct__k2r9zo = subtypeNotRegisteredMessageJson(type, deserializer.s1n());
              var message = _destruct__k2r9zo.df();
              var hint = _destruct__k2r9zo.ef();
              // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
              var path_0 = this.u27();
              var tmp_3;
              if (this.p2q().i2o_1.n2q_1) {
                var tmp$ret$13 = jsonTree.toString();
                tmp_3 = toString(minify(tmp$ret$13));
              } else {
                tmp_3 = null;
              }
              var inputValue_0 = tmp_3;
              throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, message, path_0, hint, inputValue_0), message, -1, path_0, inputValue_0, hint);
            }
            tmp$ret$2 = readPolymorphicJson(this.p2q(), discriminator, jsonTree, actualSerializer);
          }
          tmp = tmp$ret$2;
        } catch ($p) {
          var tmp_4;
          if ($p instanceof MissingFieldException()) {
            var e = $p;
            if (contains(ensureNotNull(e.message), 'at path'))
              throw e;
            var tmp_5 = plus(e.message, ' at path: ');
            var tmp$ret$14 = this.u27();
            throw missingFieldExceptionWithNewMessage(e, tmp_5 + tmp$ret$14);
          } else {
            if ($p instanceof SerializationException()) {
              var e_0 = $p;
              throw e_0;
            } else {
              if ($p instanceof Exception()) {
                var e_1 = $p;
                // Inline function 'kotlinx.serialization.json.internal.errorFromDeserializer' call
                var path_1 = this.u27();
                var causeMessage = e_1.message;
                var shortMessage = 'Deserialization failed because of ' + (causeMessage == null ? 'an exception' : "'" + causeMessage + "' exception") + ' in the decoder';
                var tmp_6;
                if (this.p2q().i2o_1.n2q_1) {
                  var tmp$ret$19 = toString(tmp2_withExceptionHandling_this);
                  tmp_6 = toString(minify(tmp$ret$19));
                } else {
                  tmp_6 = null;
                }
                var inputValue_1 = tmp_6;
                throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, shortMessage, path_1, null, inputValue_1), shortMessage, -1, path_1, inputValue_1, null, e_1);
              } else {
                throw $p;
              }
            }
          }
        }
        return tmp;
      }
      t27(parentName, childName) {
        return childName;
      }
      s1r(descriptor) {
        var currentObject = this.h2x();
        var tmp0_subject = descriptor.x1p();
        var tmp;
        var tmp_0;
        if (equals(tmp0_subject, LIST_getInstance())) {
          tmp_0 = true;
        } else {
          tmp_0 = tmp0_subject instanceof PolymorphicKind();
        }
        if (tmp_0) {
          var tmp_1 = this.p2q();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName = descriptor.e1o();
          if (!(currentObject instanceof JsonArray())) {
            var tmp2 = 'Expected ' + getKClass(JsonArray()).j1() + ', but had ' + getKClassFromExpression(currentObject).j1() + ' as the serialized body of ' + serialName;
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.u27();
            var tmp_2;
            if (this.p2q().i2o_1.n2q_1) {
              var tmp$ret$6 = toString(currentObject);
              tmp_2 = toString(minify(tmp$ret$6));
            } else {
              tmp_2 = null;
            }
            var inputValue = tmp_2;
            throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
          }
          tmp = new (JsonTreeListDecoder())(tmp_1, currentObject);
        } else {
          if (equals(tmp0_subject, MAP_getInstance())) {
            // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
            var this_0 = this.p2q();
            var keyDescriptor = carrierDescriptor(descriptor.e1q(0), this_0.h1s());
            var keyKind = keyDescriptor.x1p();
            var tmp_3;
            var tmp_4;
            if (keyKind instanceof PrimitiveKind()) {
              tmp_4 = true;
            } else {
              tmp_4 = equals(keyKind, ENUM_getInstance());
            }
            if (tmp_4) {
              var tmp_5 = this.p2q();
              // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
              // Inline function 'kotlinx.serialization.json.internal.cast' call
              var serialName_0 = descriptor.e1o();
              if (!(currentObject instanceof JsonObject())) {
                var tmp2_0 = 'Expected ' + getKClass(JsonObject()).j1() + ', but had ' + getKClassFromExpression(currentObject).j1() + ' as the serialized body of ' + serialName_0;
                // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
                var path_0 = this.u27();
                var tmp_6;
                if (this.p2q().i2o_1.n2q_1) {
                  var tmp$ret$15 = toString(currentObject);
                  tmp_6 = toString(minify(tmp$ret$15));
                } else {
                  tmp_6 = null;
                }
                var inputValue_0 = tmp_6;
                throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, path_0, null, inputValue_0), tmp2_0, -1, path_0, inputValue_0, null);
              }
              tmp_3 = new (JsonTreeMapDecoder())(tmp_5, currentObject, descriptor);
            } else {
              if (this_0.i2o_1.z2p_1) {
                var tmp_7 = this.p2q();
                // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
                // Inline function 'kotlinx.serialization.json.internal.cast' call
                var serialName_1 = descriptor.e1o();
                if (!(currentObject instanceof JsonArray())) {
                  var tmp2_1 = 'Expected ' + getKClass(JsonArray()).j1() + ', but had ' + getKClassFromExpression(currentObject).j1() + ' as the serialized body of ' + serialName_1;
                  // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
                  var path_1 = this.u27();
                  var tmp_8;
                  if (this.p2q().i2o_1.n2q_1) {
                    var tmp$ret$23 = toString(currentObject);
                    tmp_8 = toString(minify(tmp$ret$23));
                  } else {
                    tmp_8 = null;
                  }
                  var inputValue_1 = tmp_8;
                  throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_1, path_1, null, inputValue_1), tmp2_1, -1, path_1, inputValue_1, null);
                }
                tmp_3 = new (JsonTreeListDecoder())(tmp_7, currentObject);
              } else {
                throw InvalidKeyKindException(keyDescriptor);
              }
            }
            tmp = tmp_3;
          } else {
            var tmp_9 = this.p2q();
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
            // Inline function 'kotlinx.serialization.json.internal.cast' call
            var serialName_2 = descriptor.e1o();
            if (!(currentObject instanceof JsonObject())) {
              var tmp2_2 = 'Expected ' + getKClass(JsonObject()).j1() + ', but had ' + getKClassFromExpression(currentObject).j1() + ' as the serialized body of ' + serialName_2;
              // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
              var path_2 = this.u27();
              var tmp_10;
              if (this.p2q().i2o_1.n2q_1) {
                var tmp$ret$30 = toString(currentObject);
                tmp_10 = toString(minify(tmp$ret$30));
              } else {
                tmp_10 = null;
              }
              var inputValue_2 = tmp_10;
              throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_2, path_2, null, inputValue_2), tmp2_2, -1, path_2, inputValue_2, null);
            }
            tmp = new (JsonTreeDecoder())(tmp_9, currentObject, descriptor, this.e2x_1);
          }
        }
        return tmp;
      }
      t1r(descriptor) {
      }
      d1r() {
        var tmp = this.h2x();
        return !(tmp instanceof JsonNull());
      }
      j2x(tag, enumDescriptor) {
        var tmp = this.p2q();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
        var tmp2 = this.i2x(tag);
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        var serialName = enumDescriptor.e1o();
        if (!(tmp2 instanceof JsonPrimitive())) {
          var tmp2_0 = 'Expected ' + getKClass(JsonPrimitive()).j1() + ', but had ' + getKClassFromExpression(tmp2).j1() + ' as the serialized body of ' + serialName;
          // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
          var path = this.g2x(tag);
          var tmp_0;
          if (this.p2q().i2o_1.n2q_1) {
            var tmp$ret$7 = toString(tmp2);
            tmp_0 = toString(minify(tmp$ret$7));
          } else {
            tmp_0 = null;
          }
          var inputValue = tmp_0;
          throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, path, null, inputValue), tmp2_0, -1, path, inputValue, null);
        }
        return getJsonNameIndexOrThrow(enumDescriptor, tmp, tmp2.y2q());
      }
      g28(tag, enumDescriptor) {
        return this.j2x((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor);
      }
      k2x(tag) {
        return !(this.i2x(tag) === JsonNull_getInstance());
      }
      w27(tag) {
        return this.k2x((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      l2x(tag) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.i2x(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp2 = 'Expected ' + getKClass(JsonPrimitive()).j1() + ', but had ' + getKClassFromExpression(value).j1() + ' as the serialized body of ' + 'boolean';
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.g2x(tag);
            var tmp;
            if (this.p2q().i2o_1.n2q_1) {
              var tmp$ret$7 = toString(value);
              tmp = toString(minify(tmp$ret$7));
            } else {
              tmp = null;
            }
            var inputValue = tmp;
            throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
          }
          var literal = value;
          try {
            var tmp0_elvis_lhs = get_booleanOrNull(literal);
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'boolean', tag);
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            tmp$ret$0 = tmp_0;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'boolean', tag);
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      x27(tag) {
        return this.l2x((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      m2x(tag) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.i2x(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp2 = 'Expected ' + getKClass(JsonPrimitive()).j1() + ', but had ' + getKClassFromExpression(value).j1() + ' as the serialized body of ' + 'byte';
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.g2x(tag);
            var tmp;
            if (this.p2q().i2o_1.n2q_1) {
              var tmp$ret$7 = toString(value);
              tmp = toString(minify(tmp$ret$7));
            } else {
              tmp = null;
            }
            var inputValue = tmp;
            throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
          }
          var literal = value;
          try {
            var result = parseLongImpl(literal);
            var tmp_0;
            // Inline function 'kotlin.ranges.contains' call
            var this_0 = numberRangeToNumber(-128, 127);
            if (contains_0(isInterface(this_0, ClosedRange()) ? this_0 : THROW_CCE(), result)) {
              tmp_0 = convertToByte(result);
            } else {
              tmp_0 = null;
            }
            var tmp0_elvis_lhs = tmp_0;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'byte', tag);
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }
            tmp$ret$0 = tmp_1;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'byte', tag);
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      y27(tag) {
        return this.m2x((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      n2x(tag) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.i2x(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp2 = 'Expected ' + getKClass(JsonPrimitive()).j1() + ', but had ' + getKClassFromExpression(value).j1() + ' as the serialized body of ' + 'short';
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.g2x(tag);
            var tmp;
            if (this.p2q().i2o_1.n2q_1) {
              var tmp$ret$7 = toString(value);
              tmp = toString(minify(tmp$ret$7));
            } else {
              tmp = null;
            }
            var inputValue = tmp;
            throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
          }
          var literal = value;
          try {
            var result = parseLongImpl(literal);
            var tmp_0;
            // Inline function 'kotlin.ranges.contains' call
            var this_0 = numberRangeToNumber(-32768, 32767);
            if (contains_0(isInterface(this_0, ClosedRange()) ? this_0 : THROW_CCE(), result)) {
              tmp_0 = convertToShort(result);
            } else {
              tmp_0 = null;
            }
            var tmp0_elvis_lhs = tmp_0;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'short', tag);
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }
            tmp$ret$0 = tmp_1;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'short', tag);
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      z27(tag) {
        return this.n2x((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      o2x(tag) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.i2x(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp2 = 'Expected ' + getKClass(JsonPrimitive()).j1() + ', but had ' + getKClassFromExpression(value).j1() + ' as the serialized body of ' + 'int';
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.g2x(tag);
            var tmp;
            if (this.p2q().i2o_1.n2q_1) {
              var tmp$ret$7 = toString(value);
              tmp = toString(minify(tmp$ret$7));
            } else {
              tmp = null;
            }
            var inputValue = tmp;
            throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
          }
          var literal = value;
          try {
            var result = parseLongImpl(literal);
            var tmp_0;
            // Inline function 'kotlin.ranges.contains' call
            var this_0 = numberRangeToNumber(-2147483648, 2147483647);
            if (contains_0(isInterface(this_0, ClosedRange()) ? this_0 : THROW_CCE(), result)) {
              tmp_0 = convertToInt(result);
            } else {
              tmp_0 = null;
            }
            var tmp0_elvis_lhs = tmp_0;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'int', tag);
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }
            tmp$ret$0 = tmp_1;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'int', tag);
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      a28(tag) {
        return this.o2x((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      p2x(tag) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.i2x(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp2 = 'Expected ' + getKClass(JsonPrimitive()).j1() + ', but had ' + getKClassFromExpression(value).j1() + ' as the serialized body of ' + 'long';
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.g2x(tag);
            var tmp;
            if (this.p2q().i2o_1.n2q_1) {
              var tmp$ret$7 = toString(value);
              tmp = toString(minify(tmp$ret$7));
            } else {
              tmp = null;
            }
            var inputValue = tmp;
            throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
          }
          var literal = value;
          try {
            var tmp0_elvis_lhs = parseLongImpl(literal);
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'long', tag);
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            tmp$ret$0 = tmp_0;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'long', tag);
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      b28(tag) {
        return this.p2x((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      q2x(tag) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.i2x(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp2 = 'Expected ' + getKClass(JsonPrimitive()).j1() + ', but had ' + getKClassFromExpression(value).j1() + ' as the serialized body of ' + 'float';
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.g2x(tag);
            var tmp;
            if (this.p2q().i2o_1.n2q_1) {
              var tmp$ret$7 = toString(value);
              tmp = toString(minify(tmp$ret$7));
            } else {
              tmp = null;
            }
            var inputValue = tmp;
            throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
          }
          var literal = value;
          try {
            var tmp0_elvis_lhs = get_float(literal);
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'float', tag);
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            tmp$ret$0 = tmp_0;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'float', tag);
            } else {
              throw $p;
            }
          }
        }
        var result = tmp$ret$0;
        var specialFp = this.p2q().i2o_1.g2q_1;
        if (specialFp || isFinite(result))
          return result;
        // Inline function 'kotlinx.serialization.json.internal.InvalidFloatingPointDecoded' call
        var tmp2_0 = access$nonFiniteFpMessage$tJsonExceptionsKt(result, tag);
        // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
        var hint = "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'";
        var tmp_1;
        if (this.p2q().i2o_1.n2q_1) {
          var tmp$ret$13 = toString(this.h2x());
          tmp_1 = toString(minify(tmp$ret$13));
        } else {
          tmp_1 = null;
        }
        var inputValue_0 = tmp_1;
        throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, null, hint, inputValue_0), tmp2_0, -1, null, inputValue_0, hint);
      }
      c28(tag) {
        return this.q2x((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      r2x(tag) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.i2x(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp2 = 'Expected ' + getKClass(JsonPrimitive()).j1() + ', but had ' + getKClassFromExpression(value).j1() + ' as the serialized body of ' + 'double';
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.g2x(tag);
            var tmp;
            if (this.p2q().i2o_1.n2q_1) {
              var tmp$ret$7 = toString(value);
              tmp = toString(minify(tmp$ret$7));
            } else {
              tmp = null;
            }
            var inputValue = tmp;
            throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
          }
          var literal = value;
          try {
            var tmp0_elvis_lhs = get_double(literal);
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'double', tag);
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            tmp$ret$0 = tmp_0;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'double', tag);
            } else {
              throw $p;
            }
          }
        }
        var result = tmp$ret$0;
        var specialFp = this.p2q().i2o_1.g2q_1;
        if (specialFp || isFinite_0(result))
          return result;
        // Inline function 'kotlinx.serialization.json.internal.InvalidFloatingPointDecoded' call
        var tmp2_0 = access$nonFiniteFpMessage$tJsonExceptionsKt(result, tag);
        // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
        var hint = "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'";
        var tmp_1;
        if (this.p2q().i2o_1.n2q_1) {
          var tmp$ret$13 = toString(this.h2x());
          tmp_1 = toString(minify(tmp$ret$13));
        } else {
          tmp_1 = null;
        }
        var inputValue_0 = tmp_1;
        throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, null, hint, inputValue_0), tmp2_0, -1, null, inputValue_0, hint);
      }
      d28(tag) {
        return this.r2x((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      s2x(tag) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.i2x(tag);
          if (!(value instanceof JsonPrimitive())) {
            var tmp2 = 'Expected ' + getKClass(JsonPrimitive()).j1() + ', but had ' + getKClassFromExpression(value).j1() + ' as the serialized body of ' + 'char';
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.g2x(tag);
            var tmp;
            if (this.p2q().i2o_1.n2q_1) {
              var tmp$ret$7 = toString(value);
              tmp = toString(minify(tmp$ret$7));
            } else {
              tmp = null;
            }
            var inputValue = tmp;
            throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
          }
          var literal = value;
          try {
            var tmp0_elvis_lhs = new (Char())(single(literal.y2q()));
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              unparsedPrimitive(this, literal, 'char', tag);
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            tmp$ret$0 = tmp_0.f4_1;
            break $l$block;
          } catch ($p) {
            if ($p instanceof IllegalArgumentException()) {
              var e = $p;
              unparsedPrimitive(this, literal, 'char', tag);
            } else {
              throw $p;
            }
          }
        }
        return tmp$ret$0;
      }
      e28(tag) {
        return this.s2x((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      t2x(tag) {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        var value = this.i2x(tag);
        if (!(value instanceof JsonPrimitive())) {
          var tmp2 = 'Expected ' + getKClass(JsonPrimitive()).j1() + ', but had ' + getKClassFromExpression(value).j1() + ' as the serialized body of ' + 'string';
          // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
          var path = this.g2x(tag);
          var tmp;
          if (this.p2q().i2o_1.n2q_1) {
            var tmp$ret$6 = toString(value);
            tmp = toString(minify(tmp$ret$6));
          } else {
            tmp = null;
          }
          var inputValue = tmp;
          throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, path, null, inputValue), tmp2, -1, path, inputValue, null);
        }
        var value_0 = value;
        if (!(value_0 instanceof JsonLiteral())) {
          var tmp2_0 = "Expected string value for a non-null key '" + tag + "', got null literal instead";
          var tmp4 = this.g2x(tag);
          // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
          var hint = "Use 'coerceInputValues = true' in 'Json {}' builder to coerce nulls if property has a default value.";
          var tmp_0;
          if (this.p2q().i2o_1.n2q_1) {
            var tmp$ret$10 = toString(this.h2x());
            tmp_0 = toString(minify(tmp$ret$10));
          } else {
            tmp_0 = null;
          }
          var inputValue_0 = tmp_0;
          throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, tmp4, hint, inputValue_0), tmp2_0, -1, tmp4, inputValue_0, hint);
        }
        if (!value_0.a2r_1 && !this.p2q().i2o_1.y2p_1) {
          var tmp2_1 = "String literal for value of key '" + tag + "' should be quoted";
          var tmp4_0 = this.g2x(tag);
          // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
          var hint_0 = "Use 'isLenient = true' in 'Json {}' builder to accept non-compliant JSON.";
          var tmp_1;
          if (this.p2q().i2o_1.n2q_1) {
            var tmp$ret$14 = toString(this.h2x());
            tmp_1 = toString(minify(tmp$ret$14));
          } else {
            tmp_1 = null;
          }
          var inputValue_1 = tmp_1;
          throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_1, tmp4_0, hint_0, inputValue_1), tmp2_1, -1, tmp4_0, inputValue_1, hint_0);
        }
        return value_0.c2r_1;
      }
      f28(tag) {
        return this.t2x((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      u2x(tag, inlineDescriptor) {
        var tmp;
        if (get_isUnsignedNumber(inlineDescriptor)) {
          var tmp_0 = this.p2q();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
          var tmp2 = this.i2x(tag);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName = inlineDescriptor.e1o();
          if (!(tmp2 instanceof JsonPrimitive())) {
            var tmp2_0 = 'Expected ' + getKClass(JsonPrimitive()).j1() + ', but had ' + getKClassFromExpression(tmp2).j1() + ' as the serialized body of ' + serialName;
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.g2x(tag);
            var tmp_1;
            if (this.p2q().i2o_1.n2q_1) {
              var tmp$ret$7 = toString(tmp2);
              tmp_1 = toString(minify(tmp$ret$7));
            } else {
              tmp_1 = null;
            }
            var inputValue = tmp_1;
            throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, path, null, inputValue), tmp2_0, -1, path, inputValue, null);
          }
          var lexer = StringJsonLexer(tmp_0, tmp2.y2q());
          tmp = new (JsonDecoderForUnsignedTypes())(lexer, this.p2q());
        } else {
          tmp = super.h28(tag, inlineDescriptor);
        }
        return tmp;
      }
      h28(tag, inlineDescriptor) {
        return this.u2x((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
      }
      p1r(descriptor) {
        return !(this.s27() == null) ? super.p1r(descriptor) : (new (JsonPrimitiveDecoder())(this.p2q(), this.n3(), this.e2x_1)).p1r(descriptor);
      }
    }
    initMetadataForClass($, 'AbstractJsonTreeDecoder', VOID, VOID, [JsonDecoder()]);
    AbstractJsonTreeDecoderClass = $;
  }
  return AbstractJsonTreeDecoderClass;
}
function coerceInputValue($this, descriptor, index, element) {
  var tmp0 = $this.p2q();
  var tmp$ret$0;
  $l$block_2: {
    // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
    var isOptional = descriptor.f1q(index);
    var elementDescriptor = descriptor.e1q(index);
    var tmp;
    if (isOptional && !elementDescriptor.q1p()) {
      tmp = element instanceof JsonNull();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_2;
    }
    if (equals(elementDescriptor.x1p(), ENUM_getInstance())) {
      var tmp_0;
      if (elementDescriptor.q1p()) {
        tmp_0 = element instanceof JsonNull();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_2;
      }
      var tmp0_safe_receiver = element instanceof JsonPrimitive() ? element : null;
      var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : get_contentOrNull(tmp0_safe_receiver);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = false;
        break $l$block_2;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var enumValue = tmp_1;
      var enumIndex = getJsonNameIndex(elementDescriptor, tmp0, enumValue);
      var coerceToNull = !tmp0.i2o_1.b2q_1 && elementDescriptor.q1p();
      if (enumIndex === -3 && (isOptional || coerceToNull)) {
        tmp$ret$0 = true;
        break $l$block_2;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
function throwUnknownKey($this, key) {
  var tmp2 = "Encountered an unknown key '" + key + "'";
  var tmp4 = $this.u27();
  // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
  var hint = "Use 'ignoreUnknownKeys = true' in 'Json {}' builder or '@JsonIgnoreUnknownKeys' annotation to ignore unknown keys.";
  var tmp;
  if ($this.p2q().i2o_1.n2q_1) {
    var tmp$ret$3 = $this.n3().toString();
    tmp = toString(minify(tmp$ret$3));
  } else {
    tmp = null;
  }
  var inputValue = tmp;
  throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2, tmp4, hint, inputValue), tmp2, -1, tmp4, inputValue, hint);
}
var JsonTreeDecoderClass;
function JsonTreeDecoder() {
  if (JsonTreeDecoderClass === VOID) {
    class $ extends AbstractJsonTreeDecoder() {
      constructor(json, value, descriptor, polymorphicDiscriminator, polyDescriptor) {
        polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
        polyDescriptor = polyDescriptor === VOID ? null : polyDescriptor;
        super(json, value, polymorphicDiscriminator);
        this.b2y_1 = value;
        this.c2y_1 = polyDescriptor;
        this.d2y_1 = this.n3().l3().p1();
        this.e2y_1 = this.f2x_1.b2q_1 ? null : new (JsonElementMarker())(descriptor);
        this.f2y_1 = null;
        this.g2y_1 = null;
      }
      n3() {
        return this.b2y_1;
      }
      j1s(descriptor) {
        var entries = this.d2y_1;
        $l$loop: while (entries.q1()) {
          var entry = entries.r1();
          var key = entry.m3();
          var index = getJsonNameIndex(descriptor, this.p2q(), key);
          if (!(index === -3)) {
            if (this.f2x_1.d2q_1 && coerceInputValue(this, descriptor, index, entry.n3())) {
              continue $l$loop;
            }
            var tmp0_safe_receiver = this.e2y_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              tmp0_safe_receiver.l2u(index);
            }
            this.f2y_1 = key;
            this.g2y_1 = entry.n3();
            return index;
          }
          if (!(key === this.e2x_1) && !ignoreUnknownKeys(descriptor, this.p2q())) {
            throwUnknownKey(this, key);
          }
        }
        var tmp1_safe_receiver = this.e2y_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.m2u();
        var markerIndex = tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
        if (!(markerIndex === -1)) {
          this.f2y_1 = descriptor.b1q(markerIndex);
          this.g2y_1 = null;
        }
        return markerIndex;
      }
      d1r() {
        var tmp;
        var tmp0_safe_receiver = this.e2y_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k2u_1;
        if (!(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs)) {
          tmp = super.d1r();
        } else {
          tmp = false;
        }
        return tmp;
      }
      o27(descriptor, index) {
        var tmp0_elvis_lhs = this.f2y_1;
        return tmp0_elvis_lhs == null ? descriptor.b1q(index) : tmp0_elvis_lhs;
      }
      i2x(tag) {
        var tmp0_elvis_lhs = this.g2y_1;
        return tmp0_elvis_lhs == null ? getValue(this.n3(), tag) : tmp0_elvis_lhs;
      }
      s1r(descriptor) {
        if (descriptor === this.c2y_1) {
          var tmp = this.p2q();
          var tmp2 = this.h2x();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName = this.c2y_1.e1o();
          if (!(tmp2 instanceof JsonObject())) {
            var tmp2_0 = 'Expected ' + getKClass(JsonObject()).j1() + ', but had ' + getKClassFromExpression(tmp2).j1() + ' as the serialized body of ' + serialName;
            // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
            var path = this.u27();
            var tmp_0;
            if (this.p2q().i2o_1.n2q_1) {
              var tmp$ret$6 = toString(tmp2);
              tmp_0 = toString(minify(tmp$ret$6));
            } else {
              tmp_0 = null;
            }
            var inputValue = tmp_0;
            throw JsonDecodingException().i2s(access$formatDecodingException$tJsonExceptionsKt(-1, tmp2_0, path, null, inputValue), tmp2_0, -1, path, inputValue, null);
          }
          return new (JsonTreeDecoder())(tmp, tmp2, descriptor, this.e2x_1, this.c2y_1);
        }
        return super.s1r(descriptor);
      }
    }
    initMetadataForClass($, 'JsonTreeDecoder');
    JsonTreeDecoderClass = $;
  }
  return JsonTreeDecoderClass;
}
var JsonTreeListDecoderClass;
function JsonTreeListDecoder() {
  if (JsonTreeListDecoderClass === VOID) {
    class $ extends AbstractJsonTreeDecoder() {
      constructor(json, value) {
        super(json, value);
        this.n2y_1 = value;
        this.o2y_1 = this.n2y_1.q2();
        this.p2y_1 = -1;
      }
      n3() {
        return this.n2y_1;
      }
      o27(descriptor, index) {
        return index.toString();
      }
      i2x(tag) {
        return this.n2y_1.r2(toInt(tag));
      }
      j1s(descriptor) {
        while (this.p2y_1 < (this.o2y_1 - 1 | 0)) {
          this.p2y_1 = this.p2y_1 + 1 | 0;
          return this.p2y_1;
        }
        return -1;
      }
    }
    initMetadataForClass($, 'JsonTreeListDecoder');
    JsonTreeListDecoderClass = $;
  }
  return JsonTreeListDecoderClass;
}
var JsonPrimitiveDecoderClass;
function JsonPrimitiveDecoder() {
  if (JsonPrimitiveDecoderClass === VOID) {
    class $ extends AbstractJsonTreeDecoder() {
      constructor(json, value, polymorphicDiscriminator) {
        polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
        super(json, value, polymorphicDiscriminator);
        this.w2y_1 = value;
        this.i28('primitive');
      }
      n3() {
        return this.w2y_1;
      }
      j1s(descriptor) {
        return 0;
      }
      i2x(tag) {
        // Inline function 'kotlin.require' call
        if (!(tag === 'primitive')) {
          var message = "This input can only handle primitives with 'primitive' tag";
          throw IllegalArgumentException().o2(toString(message));
        }
        return this.w2y_1;
      }
    }
    initMetadataForClass($, 'JsonPrimitiveDecoder');
    JsonPrimitiveDecoderClass = $;
  }
  return JsonPrimitiveDecoderClass;
}
var JsonTreeMapDecoderClass;
function JsonTreeMapDecoder() {
  if (JsonTreeMapDecoderClass === VOID) {
    class $ extends JsonTreeDecoder() {
      constructor(json, value, descriptor) {
        super(json, value, descriptor);
        this.j2z_1 = toList(value.w4());
        this.k2z_1 = imul(this.j2z_1.q2(), 2);
        this.l2z_1 = -1;
      }
      o27(descriptor, index) {
        var i = index / 2 | 0;
        return this.j2z_1.r2(i);
      }
      j1s(descriptor) {
        while (this.l2z_1 < (this.k2z_1 - 1 | 0)) {
          this.l2z_1 = this.l2z_1 + 1 | 0;
          return this.l2z_1;
        }
        return -1;
      }
      i2x(tag) {
        return (this.l2z_1 % 2 | 0) === 0 ? JsonPrimitive_0(tag) : getValue(this.n3(), tag);
      }
      t1r(descriptor) {
      }
    }
    initMetadataForClass($, 'JsonTreeMapDecoder');
    JsonTreeMapDecoderClass = $;
  }
  return JsonTreeMapDecoderClass;
}
//region block: exports
export {
  readPolymorphicJson as readPolymorphicJson7wfdzotvo8aj,
};
//endregion

//# sourceMappingURL=TreeJsonDecoder.mjs.map
